import Vue from "vue";
import {Button, Dialog, Image, Radio, Loading} from "element-ui";
// 不要在这里直接引入这个样式文件，
// 否则，如果原先设置自定主题样式的话，加载到本控件时，会重置成element-ui的默认主题样式
// 建议在各自项目的main.js中引入这个样式文件，哪怕是使用了vant框架的项目，只要是引用了支付组件，也需要引入以下样式文件
// import 'element-ui/lib/theme-chalk/index.css';
import extend from "extend";
import Q from "q";
import _ from "underscore";
import moment from "moment";
import QRCode from "qrcode";
import get_uuid from "nllib/src/common/get_uuid";
import wait_some_seconds from "nllib/src/common/wait_some_seconds";

import CountDown from "../count-down/0.0.2/index.vue";

import call_ccb_pc_data_interface from "../../../../../../lib/common-service/yinzhilv/call_ccb_pc_data_interface";
import call_UnionPay_b2b_data_interface from "../../../../../../lib/common-service/yinzhilv/call_UnionPay_b2b_data_interface";
import call_UnionPay_b2c_data_interface from "../../../../../../lib/common-service/yinzhilv/call_UnionPay_b2c_data_interface";
import amount_rounded_to_cents from "../../../../../../../../src/common-service/amount_rounded_to_cents";
import get_user_info from "../../../../../../lib/common-service/yinzhilv/get_user_info";
import icbc_jufutong_open_page from "../../../../../../lib/common-service/yinzhilv/icbc-jufutong/open_page";

if (!Vue.prototype._) {
    Vue.prototype._ = _;
}

export default {
    components: {
        CountDown,
        ElButton: Button,
        ElDialog: Dialog,
        ElImage: Image,
        ElRadio: Radio,
    },
    props: {},
    data() {
        return {
            selected_payment_channel_code_for_select_mode_single_choice: -1,

            flag_selected_shouxin_zhifu_for_select_mode_multiple_choice: false,
            selected_payment_channel_code_for_select_mode_multiple_choice: [],

            data_get_user_info: {
                userVo: {
                    creditStatus: -1,
                    creditMode: -1,
                },
            },

            data_get_payment_channel_entity_list: {},
            data_pay: {
                outTradeNo: ``,
                resultMap: {},
                htmlStr: ``,
                original_data: {},
            },
            data_check_payment_status: {
                paymentStatus: -1,
                original_data: {},
            },
            data_get_qing_song_fu_data: {
                ableAmount: 0,
                countAmount: 0,
                depositMount: 0,
                finalPaymentTime: ``,
                needMount: 0,
                relaxPay: -1,
                scharge: 0,
                usableAmount: 0,
            },

            payment_status_define: {
                payment_status_success: null,
                payment_status_failure: null,
            },

            payment_channel_entity_list: [],
            data_get_params: {
                companyId: -1,
                clubId: -1, //中间社id
                orderNo: ``, //订单编号
                businessContent: ``, //不用管里面的值是什么，订单详情返回的businessContent,直接传入到这里
                isUseCredit: true, //是否允许授信支付
                subject: ``,
                orderAmount: 0, //订单金额，用于计算可以用哪些支付方式支付
            },

            dialog_qrcode: {
                visible: false,
                //关闭场景：
                //000:由用户手动点击关闭按钮关闭
                //100:支付轮询时，支付成功关闭
                close_situation: `000`, //default|`close-by-p`
                title: `请打开支付宝扫码本二维码`,
                image_url: `https://yinzhilv-timed-task-bucket-alpha.oss-cn-shenzhen.aliyuncs.com/generate-tourism-product-data/alpha/P15459067/P15459067-qrcode.png`,
            },

            btn_pay: {
                id: `btn-pay-${get_uuid()}`,
                disabled: true,
                type: `primary`,
                text: `支付`,
                is_loading: false,
            },

            dialog_qing_song_fu: {
                is_show: false,
            },

            panel_qing_song_fu: {
                is_show: false,
                is_checked: false,
                defer_init_completed: Q.defer(),
            },

            loading: {
                instance: null,
                flag: false,
            },
            is_loading_payment_channel_entity_list: false,

            timer_to_check_payment_status: {
                id_setInterval: null,
            },

            payment_amount: -1,

            init_parameter: {
                btn_pay: {
                    text: `支付`,
                },

                count_down: {
                    enable: true,
                    pay_remaining_seconds: 0, //支付剩余时间，以秒为单位
                },

                ui_show: {
                    is_show_header_container: true,
                    is_show_header_container_amount_to_be_paid: false,
                    is_show_payment_amount_container: true,
                    is_show_button_container: true,
                },

                get_payment_channel_entity_list: null,
                pay: null,
                check_payment_status: null,
                user_cancel_pay_event_handler: null,

                //-----从外部（init方法）传入开始-----------------------------------------------------------------------
                get_params: null,
                get_qing_song_fu_data: null,
                before_pay_event_handler: null,
                pay_successful_event_handler: null,
                pay_failed_event_handler: null,
                //-----从外部（init方法）传入结束-----------------------------------------------------------------------

            },

        };
    },
    computed: {
        payment_amount_text() {
            const __this = this;
            if (__this.payment_amount <= 0) {
                __this.payment_amount = __this.data_get_params.orderAmount;
            }
            const r = amount_rounded_to_cents(__this.payment_amount);
            return r;
        },

        order_amount_text() {
            const __this = this;
            const orderAmount = __this.data_get_params.orderAmount;
            const r = amount_rounded_to_cents(orderAmount);
            return r;
        },

        payment_channel_entity_shouxin_zhifu() {
            const __this = this;
            const payment_channel_entity_list = __this.payment_channel_entity_list;

            let r = _.chain(payment_channel_entity_list)
                .find(function (m) {
                    //6:胤之旅授信支付
                    //24:浩旅授信支付
                    return _.contains([6, 24], m.code);
                })
                .value();
            if (!r) {
                r = {};
                r.code = -1;
                r.amount_number = 0;
            }
            return r;
        },

        payment_channel_entity_qianbao_zhifu() {
            const __this = this;
            const payment_channel_entity_list = __this.payment_channel_entity_list;

            let r = _.chain(payment_channel_entity_list)
                .find(function (m) {
                    //4:胤之旅钱包支付
                    //23:浩旅钱包支付
                    return _.contains([4, 23], m.code);
                })
                .value();
            if (!r) {
                r = {};
                r.code = -1;
                r.amount_number = 0;
            }
            return r;
        },

        select_mode() {
            const __this = this;

            const payment_channel_entity_shouxin_zhifu =
                __this.payment_channel_entity_shouxin_zhifu;
            const payment_channel_entity_qianbao_zhifu =
                __this.payment_channel_entity_qianbao_zhifu;

            //授信额度
            const amount_shouxin_zhifu =
                payment_channel_entity_shouxin_zhifu.amount_number;
            //钱包余额
            const amount_qianbao_zhifu =
                payment_channel_entity_qianbao_zhifu.amount_number;
            //订单金额
            const orderAmount = __this.data_get_params.orderAmount;

            let r;
            if (payment_channel_entity_shouxin_zhifu.code <= -1) {
                //没有返回授信支付，即该用户未开通授信支付
                //单选模式
                r = `single-choice`;
                return r;
            }

            if (amount_shouxin_zhifu >= orderAmount) {
                //授信额度 >= 订单金额
                //单选模式
                r = `single-choice`;
            } else {
                //授信额度 < 订单金额
                //多选模式
                r = `multiple-choice`;
            }
            return r;
        },

        selected_payment_channel_entity_code_list() {
            const __this = this;
            const select_mode = __this.select_mode;
            const payment_channel_entity_shouxin_zhifu =
                __this.payment_channel_entity_shouxin_zhifu;
            let r = [];
            if (select_mode === `single-choice`) {
                const selected_payment_channel_code_for_select_mode_single_choice =
                    __this.selected_payment_channel_code_for_select_mode_single_choice;
                if (
                    selected_payment_channel_code_for_select_mode_single_choice !== -1
                ) {
                    r = [selected_payment_channel_code_for_select_mode_single_choice];
                }
            }
            if (select_mode === `multiple-choice`) {
                const flag_selected_shouxin_zhifu_for_select_mode_multiple_choice =
                    __this.flag_selected_shouxin_zhifu_for_select_mode_multiple_choice;
                if (flag_selected_shouxin_zhifu_for_select_mode_multiple_choice) {
                    if (payment_channel_entity_shouxin_zhifu) {
                        const code = payment_channel_entity_shouxin_zhifu.code;
                        r.push(code);
                    }
                }
                const selected_payment_channel_code_for_select_mode_multiple_choice =
                    __this.selected_payment_channel_code_for_select_mode_multiple_choice;
                r = r.concat(
                    selected_payment_channel_code_for_select_mode_multiple_choice
                );
            }
            return r;
        },

        selected_payment_channel_entity_list() {
            const __this = this;
            const payment_channel_entity_list = __this.payment_channel_entity_list;
            const selected_payment_channel_entity_code_list =
                __this.selected_payment_channel_entity_code_list;
            const list = _.chain(payment_channel_entity_list)
                .filter(function (m) {
                    const code = m.code;
                    return _.contains(selected_payment_channel_entity_code_list, code);
                })
                .value();
            return list;
        },

        //非授权支付外的另一个支付方式
        selected_payment_channel_entity_exclude_shouxin_zhifu() {
            const __this = this;
            const selected_payment_channel_entity_list =
                __this.selected_payment_channel_entity_list;
            const r = _.chain(selected_payment_channel_entity_list)
                .find(function (m) {
                    //6:胤之旅授信支付
                    //24:差旅授信支付
                    return !_.contains([6, 24], m.code);
                })
                .value();
            return r;
        },
    },
    watch: {
        selected_payment_channel_code_for_select_mode_single_choice(pNewValue, pOldValue) {
            const __this = this;
            __this.__init_payment_channel_entity_payment_amount();
            __this.__init_btn_pay_disable();
        },

        flag_selected_shouxin_zhifu_for_select_mode_multiple_choice(pNewValue, pOldValue) {
            const __this = this;
            __this.__init_payment_channel_entity_shouxin_zhifu_enable();
            __this.__init_payment_channel_entity_qianbao_zhifu_enable();
            __this.__init_payment_channel_entity_payment_amount();
            __this.__init_btn_pay_disable();
            __this.__clear_selected_value();
        },

        selected_payment_channel_code_for_select_mode_multiple_choice(pNewValue, pOldValue) {
            const __this = this;
            __this.__init_payment_channel_entity_shouxin_zhifu_enable();
            __this.__init_payment_channel_entity_qianbao_zhifu_enable();
            __this.__init_payment_channel_entity_payment_amount();
            __this.__init_btn_pay_disable();
        },

        'panel_qing_song_fu.is_checked'(pNewValue, pOldValue) {
            const __this = this;
            if (pNewValue) {
                __this.dialog_qing_song_fu.is_show = true;
                __this.payment_amount = __this.data_get_qing_song_fu_data.needMount;
            } else {
                __this.payment_amount = __this.data_get_params.orderAmount;
            }

            __this.__init_payment_channel_entity_payment_amount();
        },
    },
    methods: {
        __init_payment_channel_entity_list() {
            const __this = this;
            const get_payment_channel_entity_list =
                __this.init_parameter.get_payment_channel_entity_list;

            return Q.when()
                .then(function (data) {
                    __this.is_loading_payment_channel_entity_list = true;
                    return get_payment_channel_entity_list({
                        __this,
                    });
                })
                .then(function (data) {
                    __this.is_loading_payment_channel_entity_list = false;
                    const data_get_payment_channel_entity_list = data.data_get_payment_channel_entity_list;
                    const __payment_channel_entity_list = data.payment_channel_entity_list;

                    __this.data_get_payment_channel_entity_list = data_get_payment_channel_entity_list;

                    const payment_channel_entity_list = _.chain(__payment_channel_entity_list)
                        .map(function (m) {
                            const o = extend({}, m);
                            o.enable = true;
                            o.amount_string = m.amount;
                            o.amount_number = Number.parseFloat(o.amount_string);
                            o.payment_amount_string = `0.00`;
                            o.payment_amount_number = Number.parseFloat(
                                o.payment_amount_string
                            );
                            return o;
                        })
                        .value();
                    // console.log(payment_channel_entity_list);
                    __this.payment_channel_entity_list = payment_channel_entity_list;

                    if (payment_channel_entity_list.length === 1) {
                        const first_payment_channel_entity = payment_channel_entity_list[0];
                        const code = first_payment_channel_entity.code;

                        const select_mode = __this.select_mode;
                        if (select_mode === `single-choice`) {
                            __this.selected_payment_channel_code_for_select_mode_single_choice = code;
                        }
                    }
                })
                .catch(function (ex) {
                    __this.is_loading_payment_channel_entity_list = false;
                    if (ex) {
                        const enable_log_error = !ex.disable_log_error;
                        if (enable_log_error) {
                            console.error(ex);
                            console.trace();
                            if (ex.stack) {
                                console.error(ex.stack);
                            }
                        }
                    }
                    return Q.reject(ex);
                });
        },

        __init_payment_channel_entity_shouxin_zhifu_enable() {
            const __this = this;
            const select_mode = __this.select_mode;

            const payment_channel_entity_shouxin_zhifu =
                __this.payment_channel_entity_shouxin_zhifu;
            const payment_channel_entity_qianbao_zhifu =
                __this.payment_channel_entity_qianbao_zhifu;

            //授信额度
            const amount_shouxin_zhifu =
                payment_channel_entity_shouxin_zhifu.amount_number;
            //钱包余额
            const amount_qianbao_zhifu =
                payment_channel_entity_qianbao_zhifu.amount_number;
            //订单金额
            const orderAmount = __this.data_get_params.orderAmount;

            if (amount_shouxin_zhifu <= 0) {
                payment_channel_entity_shouxin_zhifu.enable = false;
            } else {
                payment_channel_entity_shouxin_zhifu.enable = true;
            }
        },

        __init_payment_channel_entity_qianbao_zhifu_enable() {
            const __this = this;
            const select_mode = __this.select_mode;

            const payment_channel_entity_shouxin_zhifu =
                __this.payment_channel_entity_shouxin_zhifu;
            const payment_channel_entity_qianbao_zhifu =
                __this.payment_channel_entity_qianbao_zhifu;

            //授信额度
            const amount_shouxin_zhifu =
                payment_channel_entity_shouxin_zhifu.amount_number;
            //钱包余额
            const amount_qianbao_zhifu =
                payment_channel_entity_qianbao_zhifu.amount_number;
            //订单金额
            const orderAmount = __this.data_get_params.orderAmount;

            if (select_mode === `single-choice`) {
                //单选模式下，钱包支付是否可用，需要用钱包余额与订单金额相比较
                if (amount_qianbao_zhifu >= orderAmount) {
                    payment_channel_entity_qianbao_zhifu.enable = true;
                } else {
                    payment_channel_entity_qianbao_zhifu.enable = false;
                }
            }

            if (select_mode === `multiple-choice`) {
                //多选模式下
                const selected_payment_channel_entity_code_list =
                    __this.selected_payment_channel_entity_code_list;
                if (
                    _.contains(selected_payment_channel_entity_code_list, 6) ||
                    _.contains(selected_payment_channel_entity_code_list, 24)
                ) {
                    //6:胤之旅授信支付
                    //24:差旅授信支付
                    //如果选择了授信支付
                    //钱包支付是否可用，需要用钱包余额与差额相比较
                    const difference_amount = amount_rounded_to_cents(
                        orderAmount - amount_shouxin_zhifu,
                        {
                            return_type: `number`,
                        }
                    );
                    if (amount_qianbao_zhifu >= difference_amount) {
                        payment_channel_entity_qianbao_zhifu.enable = true;
                    } else {
                        payment_channel_entity_qianbao_zhifu.enable = false;
                    }
                } else {
                    //如果没有选择授信支付
                    //钱包支付是否可用，需要用钱包余额与订单金额相比较
                    if (amount_qianbao_zhifu >= orderAmount) {
                        payment_channel_entity_qianbao_zhifu.enable = true;
                    } else {
                        payment_channel_entity_qianbao_zhifu.enable = false;
                    }
                }
            }
        },

        __init_payment_channel_entity_payment_amount() {
            const __this = this;

            const payment_channel_entity_list = __this.payment_channel_entity_list;
            const select_mode = __this.select_mode;
            const selected_payment_channel_entity_code_list = __this.selected_payment_channel_entity_code_list;
            const payment_channel_entity_shouxin_zhifu = __this.payment_channel_entity_shouxin_zhifu;
            const payment_channel_entity_qianbao_zhifu = __this.payment_channel_entity_qianbao_zhifu;

            //授信额度
            const amount_shouxin_zhifu = payment_channel_entity_shouxin_zhifu.amount_number;
            //钱包余额
            const amount_qianbao_zhifu = payment_channel_entity_qianbao_zhifu.amount_number;
            //支付金额（因为有可能选择轻松付，轻松付只支付定金，所以不一定是订单金额）
            const orderAmount = __this.payment_amount;

            _.each(payment_channel_entity_list, function (m) {
                m.payment_amount_string = `0.00`;
                m.payment_amount_number = Number.parseFloat(m.payment_amount_string);
            });

            if (select_mode === `single-choice`) {
                if (selected_payment_channel_entity_code_list.length === 1) {
                    const code = selected_payment_channel_entity_code_list[0];
                    const query = _.chain(payment_channel_entity_list)
                        .find(function (m) {
                            return m.code === code;
                        })
                        .value();
                    if (!query) {
                        const msg = "__init_payment_channel_entity_payment_amount parameter error, code=001";
                        console.error(msg);
                        console.trace();
                        return;
                    }
                    query.payment_amount_number = orderAmount;
                    query.payment_amount_string = amount_rounded_to_cents(query.payment_amount_number);
                }
            }

            if (select_mode === `multiple-choice`) {
                if (selected_payment_channel_entity_code_list.length === 1) {
                    //如果只选中了一个
                    const code = selected_payment_channel_entity_code_list[0];
                    if (_.contains([6, 24], code)) {
                        //6:胤之旅授信支付
                        //24:差旅授信支付
                        //如果选中的是授信
                        //显示的金额等于授信额度
                        payment_channel_entity_shouxin_zhifu.payment_amount_number = amount_shouxin_zhifu;
                        payment_channel_entity_shouxin_zhifu.payment_amount_string = amount_rounded_to_cents(
                            payment_channel_entity_shouxin_zhifu.payment_amount_number
                        );
                    } else {
                        //如果选中的不是授信
                        //显示的金额等于订单金额
                        const query = _.chain(payment_channel_entity_list)
                            .find(function (m) {
                                return m.code === code;
                            })
                            .value();
                        if (!query) {
                            return;
                        }
                        query.payment_amount_number = orderAmount;
                        query.payment_amount_string = amount_rounded_to_cents(
                            query.payment_amount_number
                        );
                    }
                }

                if (selected_payment_channel_entity_code_list.length === 2) {
                    //如果选中的有两个，即必有一个是授信支付

                    //授信支付显示的金额为授信额度
                    payment_channel_entity_shouxin_zhifu.payment_amount_number = amount_shouxin_zhifu;
                    payment_channel_entity_shouxin_zhifu.payment_amount_string = amount_rounded_to_cents(payment_channel_entity_shouxin_zhifu.payment_amount_number);

                    const code = _.chain(selected_payment_channel_entity_code_list)
                        .find(function (m) {
                            //6:胤之旅授信支付
                            //24:差旅授信支付
                            return !_.contains([6, 24], m);
                        })
                        .value();
                    if (code === undefined) {
                        const msg =
                            "__init_payment_channel_entity_payment_amount parameter error, code=102";
                        console.error(msg);
                        console.trace();
                        return;
                    }
                    const query = _.chain(payment_channel_entity_list)
                        .find(function (m) {
                            return m.code === code;
                        })
                        .value();
                    if (!query) {
                        return;
                    }

                    const difference_amount = amount_rounded_to_cents(
                        orderAmount - amount_shouxin_zhifu,
                        {
                            return_type: `number`,
                        }
                    );

                    //除授信支付外的另一个支付方式的金额，显示的是差额
                    query.payment_amount_number = difference_amount;
                    query.payment_amount_string = amount_rounded_to_cents(
                        query.payment_amount_number
                    );
                }
            }
        },

        __clear_selected_value() {
            const __this = this;
            const select_mode = __this.select_mode;
            const selected_payment_channel_entity_code_list =
                __this.selected_payment_channel_entity_code_list;
            const payment_channel_entity_qianbao_zhifu =
                __this.payment_channel_entity_qianbao_zhifu;

            if (select_mode === `multiple-choice`) {
                //如果当前是多选模式
                if (selected_payment_channel_entity_code_list.length === 1) {
                    //如果当前只选择了一个
                    const code = selected_payment_channel_entity_code_list[0];
                    if (_.contains([4, 23], code)) {
                        //如果选择的是钱包支付
                        //4:胤之旅钱包支付
                        //23:浩旅钱包支付

                        //钱包余额
                        const amount_qianbao_zhifu =
                            payment_channel_entity_qianbao_zhifu.amount_number;
                        //订单金额
                        const orderAmount = __this.data_get_params.orderAmount;

                        if (amount_qianbao_zhifu < orderAmount) {
                            //如果钱包余额 < 订单金额
                            //清空选中的所有支付方式
                            __this.flag_selected_shouxin_zhifu_for_select_mode_multiple_choice = false;
                            __this.selected_payment_channel_code_for_select_mode_multiple_choice = -1;
                        }
                    }
                }
            }
        },

        __init_btn_pay_disable() {
            const __this = this;
            const selected_payment_channel_entity_list = __this.selected_payment_channel_entity_list;
            const orderAmount = __this.data_get_params.orderAmount;

            __this.btn_pay.disabled = false;

            if (selected_payment_channel_entity_list.length <= 0) {
                __this.btn_pay.disabled = true;
                return;
            }

            if (__this.panel_qing_song_fu.is_checked) {
                return;
            }

            let sum_amount = 0;
            _.each(selected_payment_channel_entity_list, function (m) {
                sum_amount += m.payment_amount_number;
            });
            sum_amount = parseFloat(sum_amount.toFixed(2));
            if (sum_amount < orderAmount) {
                __this.btn_pay.disabled = true;
                return;
            }
        },

        __init_count_down() {
            const __this = this;
            const enable = __this.init_parameter.count_down.enable;
            if (enable) {
                __this.$refs.aCountDown.show();
            } else {
                __this.$refs.aCountDown.hide();
            }
        },

        __init_qing_song_fu() {
            const __this = this;
            const get_qing_song_fu_data = __this.init_parameter.get_qing_song_fu_data;
            if (!_.isFunction(get_qing_song_fu_data)) {
                return Q.resolve();
            }

            return Q.when()
                .then(function () {
                    __this.panel_qing_song_fu.is_show = false;
                    return get_qing_song_fu_data();
                })
                .then(function (data) {
                    __this.data_get_qing_song_fu_data = data;
                    const relaxPay = __this.data_get_qing_song_fu_data.relaxPay;
                    if (relaxPay === 1) {
                        __this.panel_qing_song_fu.is_show = true;
                    }

                    __this.panel_qing_song_fu.defer_init_completed.resolve();
                })
                .catch(function (ex) {
                    if (ex) {
                        const enable_log_error = !ex.disable_log_error;
                        if (enable_log_error) {
                            console.error(ex);
                            console.trace();
                            if (ex.stack) {
                                console.error(ex.stack);
                            }
                        }
                    }
                    return Q.reject(ex);
                })
                ;
        },

        __start_timer_to_check_payment_status() {
            const __this = this;
            const check_payment_status = __this.init_parameter.check_payment_status;
            const payment_status_define = __this.payment_status_define;
            const outTradeNo = __this.data_pay.outTradeNo; //永远用toPay返回的那个outTradeNo

            const payment_status_success =
                payment_status_define.payment_status_success;
            const payment_status_failure =
                payment_status_define.payment_status_failure;

            __this.__stop_timer_to_check_payment_status();
            __this.timer_to_check_payment_status.id_setInterval = setInterval(
                function () {
                    return Q.when()
                        .then(function () {
                            return check_payment_status({
                                __this,
                                outTradeNo,
                            });
                        })
                        .then(function (data) {
                            __this.data_check_payment_status = data;
                            const paymentStatus = data.paymentStatus;

                            if (
                                !_.contains(
                                    [payment_status_success, payment_status_failure],
                                    paymentStatus
                                )
                            ) {
                                const msg = `__start_timer_to_check_payment_status parameter error, code=001`;
                                return Q.reject({msg: msg, disable_log_error: true});
                            }

                            __this.__stop_timer_to_check_payment_status();
                            __this.btn_pay.is_loading = false;
                            __this.$refs.aCountDown.hide();

                            if (paymentStatus === payment_status_failure) {
                                const pay_failed_event_handler =
                                    __this.init_parameter.pay_failed_event_handler;
                                if (_.isFunction(pay_failed_event_handler)) {
                                    pay_failed_event_handler();
                                    return;
                                }
                                const msg = `支付失败`;
                                alert(msg);
                                console.error(msg);
                                console.trace();
                                return Q.reject({msg: msg});
                            }

                            __this.dialog_qrcode.close_situation = `100`;
                            __this.dialog_qrcode.visible = false;

                            const payment_channel_entity =
                                __this.selected_payment_channel_entity_exclude_shouxin_zhifu;
                            const code = payment_channel_entity
                                ? payment_channel_entity.code
                                : ``;
                            if (!code) {
                                //找不到非授权支付的另一个支付方式
                                //即单选模式，并且只选择了授信支付
                                __this.btn_pay.disabled = true;
                                __this.btn_pay.type = `success`;
                                __this.btn_pay.text = `支付成功`;
                            }

                            //4:胤之旅钱包支付
                            if (code === 4) {
                                __this.btn_pay.disabled = true;
                                __this.btn_pay.type = `success`;
                                __this.btn_pay.text = `支付成功`;
                            }

                            //23:浩旅钱包支付
                            if (code === 23) {
                                __this.btn_pay.disabled = true;
                                __this.btn_pay.type = `success`;
                                __this.btn_pay.text = `支付成功`;
                            }

                            //1:建行龙存管的微信扫码支付
                            if (code === 1) {
                                __this.btn_pay.disabled = true;
                                __this.btn_pay.type = `success`;
                                __this.btn_pay.text = `支付成功`;
                            }

                            //2:建行龙存管的支付宝扫码支付
                            if (code === 2) {
                                __this.btn_pay.disabled = true;
                                __this.btn_pay.type = `success`;
                                __this.btn_pay.text = `支付成功`;
                            }

                            //19:工银聚合支付微信支付
                            if (code === 19) {
                                __this.btn_pay.disabled = true;
                                __this.btn_pay.type = `success`;
                                __this.btn_pay.text = `支付成功`;
                            }

                            //20:工银聚合支付支付宝支付
                            if (code === 20) {
                                __this.btn_pay.disabled = true;
                                __this.btn_pay.type = `success`;
                                __this.btn_pay.text = `支付成功`;
                            }

                            //3:个人网银
                            //9:企业网银
                            //10:个人信用卡网银
                            if (_.contains([3, 9, 10], code)) {
                            }

                            //7:企业银联
                            if (code === 7) {
                            }

                            //8:个人银联
                            if (code === 8) {
                            }

                            //5:易宝支付
                            if (code === 5) {
                            }

                            //21:原始的微信扫码支付
                            if (code === 21) {
                                __this.btn_pay.disabled = true;
                                __this.btn_pay.type = `success`;
                                __this.btn_pay.text = `支付成功`;
                            }

                            //22:原始的支付宝扫码支付
                            if (code === 22) {
                            }

                            //25:原始的支付宝app支付
                            if (code === 25) {
                            }

                            //刷新授信和钱包的余额
                            return __this.__init_payment_channel_entity_list();
                        })
                        .then(function () {
                            __this.__init_can_choose_payment_channel({
                                flag: false,
                            });

                            const pay_successful_event_handler =
                                __this.init_parameter.pay_successful_event_handler;
                            if (_.isFunction(pay_successful_event_handler)) {
                                pay_successful_event_handler();
                                return;
                            }
                        })
                        .catch(function (ex) {
                            if (ex) {
                                const enable_log_error = !ex.disable_log_error;
                                if (enable_log_error) {
                                    console.error(ex);
                                    if (ex.stack) {
                                        console.error(ex.stack);
                                    }
                                }
                            }
                            return Q.reject(ex);
                        });
                },
                2 * 1000
            );
        },

        __stop_timer_to_check_payment_status() {
            const __this = this;
            clearInterval(__this.timer_to_check_payment_status.id_setInterval);
            __this.data_check_payment_status.paymentStatus = -1;
        },

        __init_can_choose_payment_channel({flag}) {
            const __this = this;
            const payment_channel_entity_list = __this.payment_channel_entity_list;
            _.each(payment_channel_entity_list, function (m) {
                m.enable = flag;
            });
        },

        __btn_pay_click() {
            const __this = this;

            const payment_channel_entity_list = __this.payment_channel_entity_list;
            const selected_payment_channel_entity_code_list = __this.selected_payment_channel_entity_code_list;
            const __selected_payment_channel_entity_list = __this.selected_payment_channel_entity_list;
            const selected_payment_channel_entity_list = _.chain(__selected_payment_channel_entity_list)
                .map(function (m) {
                    return extend(true, {}, m);
                })
                .value()
            ;

            const pay = __this.init_parameter.pay;
            // console.log(`__this.selected_payment_channel_code_for_select_mode_single_choice=${__this.selected_payment_channel_code_for_select_mode_single_choice}`);
            // console.log(`__this.flag_selected_shouxin_zhifu_for_select_mode_multiple_choice=${__this.flag_selected_shouxin_zhifu_for_select_mode_multiple_choice}`);
            // console.log(`__this.selected_payment_channel_code_for_select_mode_multiple_choice=${__this.selected_payment_channel_code_for_select_mode_multiple_choice}`);
            // console.log(selected_payment_channel_entity_list);
            // return;

            if (__this.panel_qing_song_fu.is_checked) {
                //如果用户勾选了轻松付
                //新增一个授信的支付方式，并且金额传入获取轻松付接口返回数据的尾款金额
                const ableAmount = __this.data_get_qing_song_fu_data.ableAmount;
                selected_payment_channel_entity_list.push({
                    // amount: 0,
                    // amount_number: 0,
                    // amount_string: "0.00",
                    code: 6,
                    // enable: true,
                    payment_amount_number: ableAmount,
                    // payment_amount_string: "0.00",
                    // pic: ""
                    // text: "",
                    // usable: true,
                });
            }

            const before_pay_event_handler = __this.init_parameter.before_pay_event_handler;
            let promise_before_pay_event_handler = Q.when();
            if (_.isFunction(before_pay_event_handler)) {
                promise_before_pay_event_handler = promise_before_pay_event_handler.then(function () {
                        return before_pay_event_handler();
                    }
                );
            }

            const user_cancel_pay_event_handler = __this.init_parameter.user_cancel_pay_event_handler;

            return Q.when()
                .then(function () {
                    return promise_before_pay_event_handler;
                })
                .then(function () {
                    const list = _.chain(selected_payment_channel_entity_list)
                        .filter(function (m) {
                            //需要输入支付密码的支付方式
                            //6:胤之旅授信支付
                            //24:浩旅授信支付
                            //4:胤之旅游钱包支付
                            //23:浩旅钱包支付
                            return 1 === 1 && _.contains([6, 24, 4, 23], m.code);
                        })
                        .value();
                    if (list.length > 0) {
                        //如果用户选择的是钱包支付
                        return __this.$prompt("", "请输入支付密码", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            inputType: "password",
                            closeOnClickModal: false,
                            inputValidator(pValue) {
                                const flag = !!pValue;
                                return flag;
                            },
                            inputErrorMessage: `请输入支付密码！`,
                        });
                    }
                    if (__this.panel_qing_song_fu.is_checked) {
                        //如果用户勾选了轻松付
                        return __this.$prompt("", "请输入支付密码", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            inputType: "password",
                            closeOnClickModal: false,
                            inputValidator(pValue) {
                                const flag = !!pValue;
                                return flag;
                            },
                            inputErrorMessage: `请输入支付密码！`,
                        });
                    }

                    return Q.resolve({
                        value: ``,
                    });
                })
                .then(function (data) {
                    const password = data.value;

                    __this.btn_pay.is_loading = true;

                    if (
                        _.contains(selected_payment_channel_entity_code_list, 3) ||
                        _.contains(selected_payment_channel_entity_code_list, 9) ||
                        _.contains(selected_payment_channel_entity_code_list, 10) ||
                        _.contains(selected_payment_channel_entity_code_list, 7) ||
                        _.contains(selected_payment_channel_entity_code_list, 8) ||
                        _.contains(selected_payment_channel_entity_code_list, 5) ||
                        _.contains(selected_payment_channel_entity_code_list, 22)
                    ) {
                        //如果选择的支付方式，包含：
                        //3:个人网银
                        //9:企业银联
                        //10:个人信用卡网银
                        //7:
                        //8:
                        //5:易宝
                        //22:原始支付宝扫码支付
                        //即打开第三方支付界面的支付方式，
                        //打开第三方支付界面后，
                        //仍然可以在当前页面重新支付，
                        //仍然可以在当前页面选择支付方式
                        __this.__init_can_choose_payment_channel({
                            flag: true,
                        });
                        __this.__init_payment_channel_entity_shouxin_zhifu_enable();
                        __this.__init_payment_channel_entity_qianbao_zhifu_enable();
                    } else {
                        __this.__init_can_choose_payment_channel({
                            flag: false,
                        });
                        __this.__init_payment_channel_entity_shouxin_zhifu_enable();
                        __this.__init_payment_channel_entity_qianbao_zhifu_enable();
                    }

                    return pay({
                        __this,
                        selected_payment_channel_entity_list,
                        password,
                    });
                })
                .then(function (data) {
                    __this.data_pay = data;

                    //获取非授权支付外的另一个支付方式
                    const payment_channel_entity =
                        __this.selected_payment_channel_entity_exclude_shouxin_zhifu;

                    if (!payment_channel_entity) {
                        //找不到非授权支付的另一个支付方式
                        //即单选模式，并且只选择了授信支付
                        return Q.resolve();
                    }

                    //4:胤之旅钱包支付
                    if (payment_channel_entity.code === 4) {
                        return Q.resolve();
                    }

                    //23:浩旅钱包支付
                    if (payment_channel_entity.code === 23) {
                        return Q.resolve();
                    }

                    //1:建行龙存管的微信扫码支付
                    if (payment_channel_entity.code === 1) {
                        const resultMap = data.resultMap;
                        const WECHAT = resultMap.WECHAT;
                        return QRCode.toDataURL(WECHAT).then(function (url) {
                            __this.dialog_qrcode.title = `请使用<span class="font-strong">微信</span>扫描二维码`;
                            __this.dialog_qrcode.image_url = url;
                            __this.dialog_qrcode.close_situation = `000`;
                            __this.dialog_qrcode.visible = true;
                        });
                    }

                    //2:建行龙存管的支付宝扫码支付
                    if (payment_channel_entity.code === 2) {
                        const resultMap = data.resultMap;
                        const ALIPAY = resultMap.ALIPAY;
                        return QRCode.toDataURL(ALIPAY).then(function (url) {
                            __this.dialog_qrcode.title = `请使用<span class="font-strong">支付宝</span>扫描二维码`;
                            __this.dialog_qrcode.image_url = url;
                            __this.dialog_qrcode.close_situation = `000`;
                            __this.dialog_qrcode.visible = true;
                        });
                    }

                    //19:工银聚合支付微信支付
                    if (payment_channel_entity.code === 19) {
                        const resultMap = data.resultMap;
                        const qrcodeUrl = resultMap.qrcodeUrl;
                        return QRCode.toDataURL(qrcodeUrl).then(function (url) {
                            __this.dialog_qrcode.title = `请使用<span class="font-strong">微信</span>扫描二维码`;
                            __this.dialog_qrcode.image_url = url;
                            __this.dialog_qrcode.close_situation = `000`;
                            __this.dialog_qrcode.visible = true;
                        });
                    }

                    //20:工银聚合支付支付宝支付
                    if (payment_channel_entity.code === 20) {
                        const resultMap = data.resultMap;
                        const qrcodeUrl = resultMap.qrcodeUrl;
                        return QRCode.toDataURL(qrcodeUrl).then(function (url) {
                            __this.dialog_qrcode.title = `请使用<span class="font-strong">支付宝</span>扫描二维码`;
                            __this.dialog_qrcode.image_url = url;
                            __this.dialog_qrcode.close_situation = `000`;
                            __this.dialog_qrcode.visible = true;
                        });
                    }

                    //3:个人网银
                    //9:企业网银
                    //10:个人信用卡网银
                    if (_.contains([3, 9, 10], payment_channel_entity.code)) {
                        const resultMap = data.resultMap;
                        const BODY = resultMap.BODY;
                        const CONTENTTYPE = resultMap.CONTENTTYPE;
                        const INFO = resultMap.INFO;
                        const SIGN = resultMap.SIGN;
                        return call_ccb_pc_data_interface({
                            BODY,
                            CONTENTTYPE,
                            INFO,
                            SIGN,
                        }).then(function () {
                            __this.btn_pay.is_loading = false;
                        });
                    }

                    //7:企业银联
                    if (payment_channel_entity.code === 7) {
                        const resultMap = data.resultMap;
                        return call_UnionPay_b2b_data_interface(resultMap).then(function () {
                            __this.btn_pay.is_loading = false;
                        });
                    }

                    //8:个人银联
                    if (payment_channel_entity.code === 8) {
                        const resultMap = data.resultMap;
                        return call_UnionPay_b2c_data_interface(resultMap).then(function () {
                            __this.btn_pay.is_loading = false;
                        });
                    }

                    //5:易宝支付
                    if (payment_channel_entity.code === 5) {
                        const htmlStr = data.htmlStr;
                        global.open(htmlStr);
                        __this.btn_pay.is_loading = false;
                        return Q.resolve();
                    }

                    //14:工行聚富通b2c
                    if (payment_channel_entity.code === 14) {
                        const htmlStr = data.htmlStr;
                        icbc_jufutong_open_page({
                            htmlStr,
                        });
                        __this.btn_pay.is_loading = false;
                        return Q.resolve();
                    }

                    //17:工行聚富通b2b
                    if (payment_channel_entity.code === 17) {
                        const htmlStr = data.htmlStr;
                        const url_001 = `yinzhilv-open-ie:${htmlStr}`;
                        const url_002 = url_001.replace(/&/gi, `yinzhilv-open-ie-separator`);//一定要将&替换成yinzhilv-open-ie-separator，否则参数会丢失
                        global.open(url_002);
                        __this.btn_pay.is_loading = false;
                        return Q.resolve();
                    }

                    //21:原始的微信扫码支付
                    if (payment_channel_entity.code === 21) {
                        const datas = data.datas;
                        const htmlStr = datas.htmlStr;
                        return QRCode.toDataURL(htmlStr).then(function (url) {
                            __this.dialog_qrcode.title = `请打开微信扫码本二维码`;
                            __this.dialog_qrcode.image_url = url;
                            __this.dialog_qrcode.close_situation = `000`;
                            __this.dialog_qrcode.visible = true;
                        });
                    }

                    //22:原始的支付宝扫码支付
                    if (payment_channel_entity.code === 22) {
                        const datas = data.datas;
                        const htmlStr = datas.htmlStr;

                        const wnd = window.open(`about:blank`, `_blank`);
                        wnd.document.write(htmlStr);

                        __this.btn_pay.is_loading = false;
                    }

                    //25:原始的支付宝app支付
                    if (payment_channel_entity.code === 25) {
                        const datas = data.datas;
                        const orderInfo = datas.htmlStr;

                        const __pay = function ({orderInfo}) {
                            const api = global.api;
                            const aliPayPlus = api.require("aliPayPlus");
                            const defer = Q.defer();
                            aliPayPlus.payOrder(
                                {
                                    orderInfo,
                                },
                                function (ret, err) {
                                    if (err) {
                                        defer.reject({
                                            err,
                                        });
                                        return;
                                    }
                                    defer.resolve({
                                        ret,
                                    });
                                }
                            );
                            return defer.promise;
                        };

                        return Q.when()
                            .then(function () {
                                return __pay({orderInfo});
                            })
                            .then(function ({ret}) {
                                const code = ret.code;
                                //https://docs.apicloud.com/Client-API/Open-SDK/aliPayPlus
                                // code:
                                //字符串类型；错误码，取值范围如下：
                                //9000：支付成功
                                //8000：正在处理中，支付结果未知（有可能已经支付成功），请查询商户订单列表中订单的支付状态
                                //4000：订单支付失败
                                //5000：重复请求
                                //6001：用户中途取消支付操作
                                //6002：网络连接出错
                                //6004：支付结果未知（有可能已经支付成功），请查询商户订单列表中订单的支付状态
                                if (code === `9000`) {
                                    return Q.resolve({
                                        ret,
                                    });
                                } else if (code === `6001`) {
                                    if (_.isFunction(user_cancel_pay_event_handler)) {
                                        user_cancel_pay_event_handler();
                                    }
                                    return Q.reject({
                                        ret,
                                        disable_log_error: true,
                                    });
                                } else {
                                    api.alert({
                                        title: "支付结果",
                                        msg: ret.code,
                                        buttons: ["确定"],
                                    });
                                    return Q.reject({
                                        ret,
                                    });
                                }
                            });
                    }

                })
                .then(function () {
                    __this.__start_timer_to_check_payment_status();
                })
                .catch(function (ex) {
                    __this.__init_can_choose_payment_channel({flag: true});
                    __this.__init_payment_channel_entity_shouxin_zhifu_enable();
                    __this.__init_payment_channel_entity_qianbao_zhifu_enable();
                    __this.btn_pay.is_loading = false;

                    if (ex) {
                        const enable_log_error = !ex.disable_log_error;
                        if (enable_log_error) {
                            console.error(ex);
                            console.trace();
                            if (ex.stack) {
                                console.error(ex.stack);
                            }
                        }
                    }
                    return Q.reject(ex);
                });
        },

        __btn_payment_channel_entity_row_click(p_payment_channel_entity) {
            const __this = this;

            const payment_channel_entity = p_payment_channel_entity;
            const enable = payment_channel_entity.enable;
            const code = payment_channel_entity.code;

            const select_mode = __this.select_mode;

            if (select_mode === `single-choice`) {
                if (enable) {
                    __this.selected_payment_channel_code_for_select_mode_single_choice = code;
                }
            }

            if (select_mode === `multiple-choice`) {
                if (enable) {
                    //6:胤之旅授信支付
                    //24:差旅授信支付
                    if (_.contains([6, 24], code)) {
                        //授信支付
                        __this.flag_selected_shouxin_zhifu_for_select_mode_multiple_choice = !__this.flag_selected_shouxin_zhifu_for_select_mode_multiple_choice;
                    }
                    if (!_.contains([6, 24], code)) {
                        __this.selected_payment_channel_code_for_select_mode_multiple_choice = code;
                    }
                }
            }
        },

        __set_payment_channel_disabled(pEntity) {
            const __this = this;
            // if (__this.loading.flag) {
            //   return true;
            // }
            if (!pEntity.enable) {
                return true;
            }
            // if (__this.data_check_payment_status.paymentStatus !== -1) {
            //   return true;
            // }
            return false;
        },

        __dialog_qrcode_closed_event_handler() {
            const __this = this;
            __this.btn_pay.is_loading = false;
            __this.__stop_timer_to_check_payment_status();

            if (__this.dialog_qrcode.close_situation === `000`) {
                //如果是：由用户手动点击关闭按钮关闭
                //允许选择支付方式
                __this.__init_can_choose_payment_channel({flag: true});
            }

            if (__this.dialog_qrcode.close_situation === `100`) {
                //如果是：支付轮询时，支付成功关闭
                //不允许选择支付方式
                __this.__init_can_choose_payment_channel({flag: false});
            }
        },

        __dialog_qing_song_fu_btn_close_click() {
            const __this = this;
            __this.dialog_qing_song_fu.is_show = false;
        },

        __btn_qing_song_fu_view_detail_click() {
            const __this = this;
            __this.dialog_qing_song_fu.is_show = true;
        },

        //--------------------------------------------------------------------------------------------------------------

        init(pParameter) {
            const __this = this;

            if (!pParameter) pParameter = {};

            const init_parameter = __this.init_parameter;

            init_parameter.get_params = pParameter.get_params;
            init_parameter.get_qing_song_fu_data = pParameter.get_qing_song_fu_data;
            init_parameter.before_pay_event_handler = pParameter.before_pay_event_handler;
            init_parameter.pay_successful_event_handler = pParameter.pay_successful_event_handler;
            init_parameter.pay_failed_event_handler = pParameter.pay_failed_event_handler;

            extend(init_parameter.btn_pay, pParameter.btn_pay);
            extend(init_parameter.count_down, pParameter.count_down);

            if (init_parameter.count_down.pay_remaining_seconds <= 0) {
                init_parameter.count_down.pay_remaining_seconds = 60;
            }

            __this.btn_pay.text = init_parameter.btn_pay.text;

            const get_params = init_parameter.get_params;
            if (!_.isFunction(get_params)) {
                const msg = `init parameter error，get_params, code=101`;
                console.error(msg);
                console.trace();
                return Q.reject({msg: msg});
            }

            const get_payment_channel_entity_list = init_parameter.get_payment_channel_entity_list;
            if (!_.isFunction(get_payment_channel_entity_list)) {
                const msg = `init parameter error，get_params, code=201`;
                console.error(msg);
                console.trace();
                return Q.reject({msg: msg});
            }

            const pay = init_parameter.pay;
            if (!_.isFunction(pay)) {
                const msg = `init parameter error，get_params, code=301`;
                console.error(msg);
                console.trace();
                return Q.reject({msg: msg});
            }

            const check_payment_status = init_parameter.check_payment_status;
            if (!_.isFunction(check_payment_status)) {
                const msg = `init parameter error，get_params, code=401`;
                console.error(msg);
                console.trace();
                return Q.reject({msg: msg});
            }

            const get_payment_status_define = init_parameter.get_payment_status_define;
            if (!_.isFunction(get_payment_status_define)) {
                const msg = `init parameter error，get_params, code=501`;
                console.error(msg);
                console.trace();
                return Q.reject({msg: msg});
            }
            const payment_status_define = get_payment_status_define();
            if (!payment_status_define) {
                const msg = `init parameter error，get_params, code=502`;
                console.error(msg);
                console.trace();
                return Q.reject({msg: msg});
            }
            const payment_status_success = payment_status_define.payment_status_success;
            if (
                payment_status_success === null ||
                payment_status_success === undefined
            ) {
                const msg = `init parameter error，get_params, code=503`;
                console.error(msg);
                console.trace();
                return Q.reject({msg: msg});
            }
            const payment_status_failure = payment_status_define.payment_status_failure;
            if (
                payment_status_failure === null ||
                payment_status_failure === undefined
            ) {
                const msg = `init parameter error，get_params, code=504`;
                console.error(msg);
                console.trace();
                return Q.reject({msg: msg});
            }
            __this.payment_status_define = payment_status_define;

            __this.is_loading_payment_channel_entity_list = true;
            return Q.when()
                .then(function () {
                    return get_params();
                })
                .then(function (data) {
                    if (!data) {
                        const msg = `init parameter error，get_params, code=101`;
                        console.error(msg);
                        console.trace();
                        return Q.reject({msg: msg});
                    }

                    const orderNo = data.orderNo;
                    // if (!orderNo) {
                    //     const msg = `init parameter error，get_params, code=102`;
                    //     console.error(msg);
                    //     console.trace();
                    //     return Q.reject({msg: msg});
                    // }

                    const orderAmount = data.orderAmount || 0;
                    data.orderAmount = parseFloat(orderAmount);

                    __this.data_get_params = data;

                    return Q.resolve();
                })
                .then(function () {
                    __this.__stop_timer_to_check_payment_status();
                    __this.__init_count_down();
                    return __this.__init_qing_song_fu();
                })
                .then(function () {
                    return __this.__init_payment_channel_entity_list();
                })
                .then(function (data) {
                    __this.is_loading_payment_channel_entity_list = false;

                    __this.__init_payment_channel_entity_shouxin_zhifu_enable();
                    __this.__init_payment_channel_entity_qianbao_zhifu_enable();
                    __this.__init_payment_channel_entity_payment_amount();

                    if (__this.init_parameter.count_down.enable) {
                        __this.$refs.aCountDown.init({
                            seconds: __this.init_parameter.count_down.pay_remaining_seconds,
                            time_is_running_out_event_handler: function () {
                                __this.btn_pay.disabled = true;
                                __this.btn_pay.type = `danger`;
                                __this.btn_pay.text = `支付超时`;
                            },
                        });
                    }
                })
                .catch(function (ex) {
                    console.error(ex);
                    if (ex) {
                        if (ex.stack) {
                            console.error(ex.stack);
                        }
                    }
                    return Q.reject(ex);
                });
        },

        get_selected_payment_channel_entity_list() {
            const __this = this;
            return __this.selected_payment_channel_entity_list;
        },

        trigger_pay() {
            const __this = this;
            __this.__btn_pay_click();
        },
    },
    mounted() {
        const __this = this;
    },
};
